import { NAME_DEV_SET, GetNameDevSetListByEst1 } from '../../../function/NameDevSetModel';
import ItemComboBoxStr, { ComboBoxItemTypeS } from '../../atoms/ComboBox/ItemComboBoxStr';

export type SelectDataType = {
  devIndex: string; //選択機器番号
  selectDate: string; //選択日時
  isVibrationTrend: boolean; // 振動トレンド
  isBearing: boolean; //軸受
  isRotateBar: boolean; //回転子バー損傷
  isElecTrend: boolean; //電流トレンド
  isTemperature: boolean; //温度
};


/**
 * レポートファイル取得API実行
 * @returns
 */
export const GetReportFile = (selectData : SelectDataType): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const query_params = new URLSearchParams({
        devIndex: selectData.devIndex,
        selectDate: selectData.selectDate,
        isVibrationTrend: String(selectData.isVibrationTrend),
        isBearing: String(selectData.isBearing),
        isRotateBar: String(selectData.isRotateBar),
        isElecTrend: String(selectData.isElecTrend),
        isTemperature: String(selectData.isTemperature)
    });
    let fileName = "tmp.xlsx";

    fetch("api/Report?" + query_params)
      .then(res => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          console.error(message);
          reject(message);
        }
        else {
          var disposition  =  String(res.headers.get('content-disposition'));
          fileName = getFileNameFromContentDisposition(disposition);
          console.debug(res);
          return res.blob();
        }
      })
      .then(result => {
        console.debug(result);

        if (result?.type === "application/octet-stream") {

          const downloadTag = document.createElement('a');
          downloadTag.href = URL.createObjectURL(result);
          downloadTag.download = fileName;
          console.log(result);
          downloadTag.click();
          console.debug("OK");
          resolve(true);
        }
        else {
          console.debug("NG");
          reject(false);
        }
       
      })
      .catch(function (error) {
        console.log('Request failed', error)
        reject(false);
      });
  });
};

const GetReportFileValidete = (target : SelectDataType) : boolean => {
  return true;
}

/**
 * ファイル名を返す
 * @param disposition
 * @returns
 */
const getFileNameFromContentDisposition = (disposition : string) => {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/; // 正規表現でfilenameを抜き出す
  const matches = filenameRegex.exec(disposition);
  if (matches != null && matches[1]) {
    const fileName = matches[1].replace(/['"]/g, '');
    return decodeURI(fileName) // 日本語対応
  } else {
    return "temp.xlsx";
  }
};

/**
 *　画面で使用するコンボボックスアイテムリストを作成
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateCombBoxItems = (nameDevSets: NAME_DEV_SET[]): ComboBoxItemTypeS[] => {
  let comboItems: ComboBoxItemTypeS[] = [];
  nameDevSets.forEach((r) => {
    let item: ComboBoxItemTypeS = {
      key: r.DEV_INDEX.toString(),
      name: `${r.DEV_NO} ${r.DEV_NAME}`,
    };
    comboItems.push(item);
  });
  return comboItems;
};
